module.exports = __webpack_public_path__ + "static/media/4.0891d49f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/thumbnails/4.jpg
// module id = 986
// module chunks = 0